import { Input, OnInit } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { assign } from 'lodash';

import { UnitTypeMetric, PropertyDetailJSON } from '~core/model';
import { GridBaseComponent, Grid, COLUMN_TYPE } from '~/shared/components/grids';
import { PropertyMetric } from '~/core/model/Property';
import { AppConstants } from '~/shared/utils/app-constants';

@Grid({
  title: '',
  selector: 'unit-type-grid'
})

export class UnitTypeGrid extends GridBaseComponent<UnitTypeMetric> implements OnInit {
  @Input() property: Observable<PropertyMetric>;

  constructor() {
    super();
  }

  ngOnInit() {
    this.data = this.property
      .map(property => {
        if(property.type === AppConstants.TYPES.STUDENT_HOUSING) {
          this.columnDefinitions.next([
            { label: 'Bedroom Type', property: 'unitType', cellClass: 'text-center text-blue', headerClass: 'text-center' },
            { label: 'Beds', property: 'metrics.bedCount', cellClass: 'text-center', headerClass: 'text-center', sortable: true, type: COLUMN_TYPE.DECIMAL },
            { label: 'Avg Sq Ft(Per Bed)', property: 'totalSquareFootage', cellClass: 'text-center', headerClass: 'text-center', sortable: true, type: COLUMN_TYPE.DECIMAL },
            { label: 'Occupancy(Per Bed)', property: 'metrics.occupancy', cellClass: 'text-center', headerClass: 'text-center', sortable: true, type: COLUMN_TYPE.PERCENTAGE, decimals: 1 },
            { label: 'Effective Rent(Per Bed)', property: 'metrics.effective.rent', cellClass: 'text-center', headerClass: 'text-center', sortable: true, type: COLUMN_TYPE.CURRENCY },
            { label: 'Effective RPSF(Per Bed)', property: 'metrics.effective.rentPerSquareFoot', cellClass: 'text-center', headerClass: 'text-center', sortable: true, type: COLUMN_TYPE.CURRENCY, decimals: 3 },
            { label: 'Annual Rent Change(Per Bed)', property: 'metrics.rentChange', cellClass: 'text-center', headerClass: 'text-center', sortable: true, type: COLUMN_TYPE.PERCENTAGE, decimals: 1 },
            { label: 'Asking Rent(Per Bed)', property: 'metrics.asking.rent', cellClass: 'text-center', headerClass: 'text-center', sortable: true, type: COLUMN_TYPE.CURRENCY },
            { label: 'Concessions(Per Bed)', property: 'metrics.concessions', cellClass: 'text-center', headerClass: 'text-center', sortable: true, type: COLUMN_TYPE.PERCENTAGE, decimals: 1 },
          ]);
        } else {
          this.columnDefinitions.next([
            { label: 'Unit Type', property: 'unitType', cellClass: 'text-center text-blue', headerClass: 'text-center' },
            { label: 'Units', property: 'unitCount', cellClass: 'text-center', headerClass: 'text-center', sortable: true, type: COLUMN_TYPE.DECIMAL },
            { label: 'Avg Sq Ft', property: 'totalSquareFootage', cellClass: 'text-center', headerClass: 'text-center', sortable: true, type: COLUMN_TYPE.DECIMAL },
            { label: 'Occupancy', property: 'metrics.occupancy', cellClass: 'text-center', headerClass: 'text-center', sortable: true, type: COLUMN_TYPE.PERCENTAGE, decimals: 1 },
            { label: 'Effective Rent', property: 'metrics.effective.rent', cellClass: 'text-center', headerClass: 'text-center', sortable: true, type: COLUMN_TYPE.CURRENCY },
            { label: 'Effective RPSF', property: 'metrics.effective.rentPerSquareFoot', cellClass: 'text-center', headerClass: 'text-center', sortable: true, type: COLUMN_TYPE.CURRENCY, decimals: 3 },
            { label: 'Annual Rent Change', property: 'metrics.rentChange', cellClass: 'text-center', headerClass: 'text-center', sortable: true, type: COLUMN_TYPE.PERCENTAGE, decimals: 1 },
            { label: 'Asking Rent', property: 'metrics.asking.rent', cellClass: 'text-center', headerClass: 'text-center', sortable: true, type: COLUMN_TYPE.CURRENCY },
            { label: 'Concessions', property: 'metrics.concessions', cellClass: 'text-center', headerClass: 'text-center', sortable: true, type: COLUMN_TYPE.PERCENTAGE, decimals: 1 },
          ]);
        }

        return ({
          data: property.unitTypes,
          average: assign({}, property, {
            unitType: 'Total / Average',
            totalSquareFootage: property.averageSquareFootage
          }) as any
        });
      })
      .share();

    this.gridOptions = Observable.of({
      headerHeight: 28
    });

    super.ngOnInit();
  }
}



// WEBPACK FOOTER //
// ./src/app/features/property/components/grids/unit-type.grid.ts